import { FC } from 'react'
import { useTranslation } from 'react-i18next'

import { TableNoResults } from '@ui/v2/Table/Table'

interface EmptyIBClientsTableProps {
  isAnyFilterActive?: boolean
}

export const EmptyIBClientsTable: FC<EmptyIBClientsTableProps> = (props) => {
  const { isAnyFilterActive } = props

  const { t } = useTranslation()

  return (
    <TableNoResults
      title={t('Nothing here... yet.')}
      content={isAnyFilterActive && t('Check your query!')}
    />
  )
}
